import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer1WycinkaKlasyczna from "../../components/offer/1wycinkaKlasyczna";

function K1WycinkaKlasyczna() {
  return (
    <>
      <Helmet>
        <title>Wycinka drzew z działek pod budowę i inwestycje | Gdańsk, Gdynia, Wejherowo</title>
        <meta name="title" content="Wycinka drzew z działek pod budowę i inwestycje | Gdańsk, Gdynia, Wejherowo" />
        <meta
          name="description"
          content="Profesjonalna wycinka drzew metodą klasyczną z działek budowlanych i terenów inwestycyjnych. Szybka realizacja w Gdańsku, Gdyni, Kartuzach i województwie pomorskim."
          key="desc"
        />
        <meta
          property="og:title"
          content="Wycinka drzew z działek pod budowę i inwestycje | Gdańsk, Gdynia, Wejherowo"
        />
        <meta
          property="og:description"
          content="Profesjonalna wycinka drzew metodą klasyczną z działek budowlanych i terenów inwestycyjnych. Szybka realizacja w Gdańsku, Gdyni, Kartuzach i województwie pomorskim."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer1WycinkaKlasyczna />
      </main>
      <Footer />
    </>
  );
}
export default K1WycinkaKlasyczna;
